<div
  class="blog-block-paragraph"
  [innerHTML]="processedHtml"
></div>
